import {AxiosError} from 'axios'
import {UseMutationOptions} from 'react-query'

import {API} from '../../../networking/http'
import {MembershipCancelRequest} from '../types'

export type WithdrawMembershipCancelRequestOptions = {
  subscriptionId: string
  requestId: string
}

export type WithdrawMembershipCancelRequestMutationReturnType = MembershipCancelRequest

export const withdrawMembershipCancelRequestEndpoint = (subscriptionId: string, requestId: string) =>
  `memberships/${subscriptionId}/cancel-requests/${requestId}/withdraw`

export type WithdrawMembershipCancelRequestMuOp = UseMutationOptions<
  WithdrawMembershipCancelRequestMutationReturnType,
  AxiosError,
  WithdrawMembershipCancelRequestOptions
>

export const withdrawMembershipCancelRequest = (
  params?: WithdrawMembershipCancelRequestMuOp,
): WithdrawMembershipCancelRequestMuOp => ({
  mutationFn: async (options) => {
    const res = await API.post<undefined, WithdrawMembershipCancelRequestMutationReturnType>(
      withdrawMembershipCancelRequestEndpoint(options.subscriptionId, options.requestId),
    )
    return res.data
  },
  ...params,
})
